import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChartPie, FaTasks, FaCalendarAlt } from "react-icons/fa";

const iconMap = {
  "Dashboard": <FaChartPie style={{ color: "Plum" }} />,
  "Recent Queries": <FaCalendarAlt style={{ color: "yellow" }} />,
  "Login Queries": <FaTasks style={{ color: "pink" }} />,
};

const superAdminLinks = [
  { to: "/superadmin/dashboard", name: "Dashboard" },
  { to: "/superadmin/recent-query", name: "Recent Queries" },
  { to: "/superadmin/login-query", name: "Login Queries" },
];

const SuperAdminSidebar = () => {
  const { pathname } = useLocation();

  const navigationLinks = superAdminLinks;
  return (
    <div style={{ width: "220px", minHeight: "100vh", backgroundColor: "#212529", color: "white" }}>
      <ul className="list-unstyled p-3 mt-3 mb-0">
        <h5 className="mx-2">Superadmin System</h5>
        <hr className="m-1" />
        {navigationLinks.map((link) => {
          const access = link.access !== false;
          return (
            <li
              key={link.to}
              className={`p-2 d-flex align-items-center ${pathname === link.to ? "bg-light text-dark" : ""}`}
              style={{ opacity: access ? 1 : 0.5, pointerEvents: access ? "auto" : "none" }}
              title={access ? "" : "Access Denied"}
            >
              <Link
                to={access ? link.to : "#"}
                className="text-decoration-none d-flex align-items-center w-100"
                style={{ color: pathname === link.to ? "#000" : "#fff", fontSize: ".8rem", fontWeight: "200" }}
              >
                <span className="me-2" style={{ fontSize: ".9rem" }}>
                  {iconMap[link.name] || null}
                </span>
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SuperAdminSidebar;
